import React from "react";
import useSmallNav from "../../../../hooks/useSmallNav";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../../molecules/UnderlinedHeader/UnderlinedHeader";
import InfoHero from "../../../molecules/info/InfoHero/InfoHero";
import shogun from "../../../../assets/info/shogun-sport-hero.jpg";
import InfoGrid from "../../../atoms/info/InfoGrid/InfoGrid";
import InfoHeader from "../../../atoms/info/InfoHeader/InfoHeader";
import InfoCard from "../../../molecules/info/InfoCard/InfoCard";
import part1 from "../../../../assets/info/mitsubishi-shogun-sport/ride-height-diagram-spaced_1_.jpg";
import styled from "styled-components";
import { popularVehicle } from "../../../../vars/popularVehicles";
import InfoFooter from "../../../organisms/InfoFooter/InfoFooter";

const MitsubishiShogun = () => {
  useSmallNav("Mitsubishi Shogun Sport");

  return (
    <section className={"popular"}>
      <Container>
        <UnderlinedHeader
          text={"Mitsubishi Shogun Sport (Challenger)"}
          bolder
        />
        <InfoHero image={shogun} />
        <InfoGrid>
          <div>
            <InfoHeader text={"Zawieszenie Shogun Sport (Challenger)"} />
            <p>
              Zawieszenie Trak Ryder 4WD reprezentuje wieloletni rozwój
              techniczny i zapewnia nowy poziom jazdy i komfortu właścicielom
              Mitsubishi Shogun Sport z napędem na 4 koła. Zawieszenie Pedders
              Trak Ryder składa się z setek wysokiej jakości komponentów, z
              których każdy ma na celu poprawę prowadzenia i obsługi określonych
              pojazdów w określony sposób.
            </p>
            <InfoHeader smaller text={"Więc który chcę?"} />
            <p>
              Cóż, to raczej zależy od tego, co chcesz osiągnąć. Dla tych,
              którzy po prostu szukają części zamiennych w celu zastąpienia
              zużytych oryginałów, oferujemy szeroką gamę wysokiej jakości
              części. W przypadku pojazdów z opcjonalnym, elektronicznie
              regulowanym zawieszeniem nie oferujemy obecnie zamiennika. Są one
              dostępne wyłącznie w firmie Mitsubishi. Istnieje możliwość
              zamontowania naszych amortyzatorów w pojazdach wyposażonych w
              regulowane zawieszenie, jednak wyeliminowałoby to funkcję
              regulacji.
            </p>
            <p>
              Jeśli chcesz zwiększyć wysokość swojego pojazdu lub przewieźć
              większe ładunki, mamy to, czego potrzebujesz. Oferujemy różne
              sprężyny i amortyzatory do Twojego Shogun Sport. Aby oszczędzić
              poszukiwania odpowiednich części, przygotowaliśmy dla Ciebie
              zestawy podnośników. Dodatkową zaletą jest to, że kupując je w ten
              sposób, zaoszczędzisz pieniądze!
            </p>
            <p>
              Wszystkie zestawy zawierają przednie i tylne sprężyny (w
              stosownych przypadkach drążki skrętne) oraz 4 nasze fantastyczne
              amortyzatory pianowe. Aby uzyskać szczegółowe informacje i zalety
              technologii ogniw pianowych firmy Pedders,&nbsp;
              <StyledLink href="https://www.youtube.com/watch?v=uKjltW4e6X8">
                kliknij tutaj.
              </StyledLink>
            </p>
            <InfoHeader
              size="smaller"
              text={"Czy na pewno mogę po prostu nakręcić drążki skrętne?"}
            />
            <p>
              Oczywiście, jest to prawidłowe. Jednakże w przypadku większości
              starszych modeli Shogun Sports, jak w przypadku każdej sprężyny,
              drążki skrętne opadną. Najczęściej ich nawijanie daje jedynie
              krótkotrwałą poprawę. Oprócz tego nasze drążki skrętne
              wykorzystują inną sztywność sprężyny (podobnie jak nasze
              sprężyny), zaprojektowaną tak, aby współpracowała w harmonii z
              naszymi amortyzatorami.
            </p>
            <InfoHeader
              size="smaller"
              text={"Czy wszystko, czego potrzebuję, znajduje się w zestawie?"}
            />
            <p>
              Tak. Tam, gdzie ma to zastosowanie, amortyzatory są dostarczane w
              komplecie z wymiennymi tulejami itp. Oczywiście oferujemy
              dodatkowe części, takie jak ulepszone tuleje do Twojego Shogun
              Sport.
            </p>
            <InfoHeader
              size="smaller"
              text={"Jak wysoki będzie mój Shogun Sport?"}
            />
            <p>
              Chociaż zestawy dają przybliżoną wysokość, może to być nieco
              mylące. Jak wspomniano powyżej, sprężyny z czasem osiadają, więc
              podniesienie o 1,5 cala może w rzeczywistości okazać się nieco
              większe. Aby mieć pewność, że dokładnie wiesz, co otrzymujesz,
              podajemy również dopasowaną wysokość.
            </p>
            <StyledImgParts src={part1} alt="Diagram" />
            <p>
              Mierzona jest od dołu obręczy koła do nadkola. Zaletą tej metody
              jest to, że wybór opon nie ma wpływu na podaną wysokość. Wykres po
              lewej stronie przedstawia wysokość prześwitu wynoszącą 715 mm przy
              kołach 17-calowych.
            </p>
            <p>
              Nadal nie jesteś pewien, czy mamy odpowiednie części? Nie wiesz,
              który zestaw będzie dla Ciebie odpowiedni? Skontaktuj się z nami,
              a ktoś z naszego zespołu będzie mógł Ci pomóc.
            </p>
          </div>
          <div>
            {popularVehicle
              .find((e) => e.make === "Mitsubishi")
              .models.find((e) => e.display === "Shogun Sport")
              .popular.map((item) => (
                <InfoCard
                  key={item.text}
                  name={item.text}
                  to={item.link}
                  photo={item.photo}
                />
              ))}
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/5F5cj3zCaCk"
              title={"Mitsubishi Shogun Sport Video 1"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/KnT6sI4QaYk"
              title={"Mitsubishi Shogun Sport Video 2"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/g1aSCo4S2_E"
              title={"Mitsubishi Shogun Sport Video 3"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </InfoGrid>
        {/* <InfoFooter make="Mitsubishi" model="Shogun Sport" /> */}
      </Container>
    </section>
  );
};

export default MitsubishiShogun;

const StyledLink = styled.a`
  color: #444444;

  &:hover {
    color: rgb(220, 51, 50);
  }
`;

const StyledImgParts = styled.img`
  height: 208px;
  width: 317px;
`;
